import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import WeatherCard from './WeatherCard';
import { getWeather } from '../store/weatherSlice';
import { removeCity } from '../store/cityListSlice';
import { useNavigate } from 'react-router-dom';
import { City } from '../types/weather';

const WeatherList: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const cities = useSelector((state: RootState) => state.cityList) as City[];
  const weather = useSelector((state: RootState) => state.weather);

  useEffect(() => {
    cities.forEach((city: City) => {
      dispatch(getWeather(city));
    });
  }, [dispatch, cities]);

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 10,
        maxWidth: 1040,
        margin: '0 auto',
        justifyItems: 'center',
        alignItems: 'stretch',
      }}
    >
      {cities.map((city: City) => (
        <div key={city.id} style={{ width: '100%', height: '100%', maxWidth: 250, display: 'flex', flexDirection: 'column' }}>
          <WeatherCard
            city={city.name}
            weather={weather[city.id]?.weather || null}
            loading={weather[city.id]?.loading || false}
            onRefresh={() => dispatch(getWeather(city))}
            onRemove={() => dispatch(removeCity(city.id))}
            onClick={() => navigate(`/city/${city.id}`)}
          />
        </div>
      ))}
    </div>
  );
};

export default WeatherList; 